import { httpsCallable } from 'firebase/functions';
import { functions } from '../../firebase';

const memoryTokens = new Map();
const tokenKey = (itineraryId, versionId) => `itineraryPilotClaim:${itineraryId}:${versionId}`;

export function getPilotClaimToken(itineraryId, versionId, create = false) {
  const key = tokenKey(itineraryId, versionId);
  let token = memoryTokens.get(key);
  try {
    token = window.localStorage.getItem(key) || token;
  } catch {
    // The in-memory token still makes retries safe when storage is unavailable.
  }
  if (!/^[a-f0-9]{64}$/.test(token || '')) {
    if (!create) return null;
    const bytes = new Uint8Array(32);
    window.crypto.getRandomValues(bytes);
    token = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  }
  memoryTokens.set(key, token);
  try {
    window.localStorage.setItem(key, token);
  } catch {
    // A failed request must reuse this token for the rest of the page session.
  }
  return token;
}

export async function claimPilotItinerary({ itineraryId, versionId }) {
  const claimToken = getPilotClaimToken(itineraryId, versionId, true);
  const claim = httpsCallable(functions, 'claimFreePilotItinerary');
  const response = await claim({ itineraryId, versionId, claimToken });
  return response.data;
}
